'use strict';

angular.module('clientDashboardApp').directive('summaryWithPercentChange', ['$log', '$rootScope', function ($log, $rootScope) {
  return {
    restrict: 'E',
    scope: {
      history: '=',
      newlocation: '='
    },
    template: `
      <div class="d-inline-block">
        {{title}}<br>
        <div>
          <a ng-if="link" ng-href="{{link}}" class="metric-value ss-total">{{latestValue | number:0}}{{valuePostFix}}</a>
          <span ng-if="!link" class="metric-value">{{latestValue | number:0}}{{valuePostFix}}</span>
          <span name="change-text" class="metric-value" ng-if="rankIconClass" ng-class="rankIconClass" uib-tooltip="% change over last 30 days">
              <i class="fa" ng-class="{'fa-arrow-up': rankIconImg === 'rank-higher-icon', 'fa-arrow-down': rankIconImg === 'rank-lower-icon'}"></i>
              <strong>{{changeText}}</strong>
          </span>
        </div>
      </div>
    `,
    link: function (scope, elem, attrs, ctrl) {

      scope.assetUrl = $rootScope.assetUrl
      scope.$watch('history', function (newValue, oldValue) {

        //Clear previous values
        delete scope.rankIconClass;
        delete scope.rankIconImg;
        delete scope.changeText;
        delete scope.valuePostFix;

        scope.title = attrs.title;

        //Check if we actually have a valid history object.
        if (!scope.history || scope.history.length < 1) {
          $log.warn("History has no values! Unable to calculate change over time");
          $log.warn(scope.history);
          return;
        }


        //Set the default attributes if they are missing from the element
        if (!attrs.valueType) {
          attrs.valueType = 'absolute';
        }
        if (!attrs.changeType) {
          attrs.changeType = 'percentage';
        }

        scope.valuePostFix = '';

        if (attrs.valueType === 'absolute') {
        } else if (attrs.valueType === 'percentage') {
          scope.valuePostFix = '%';
        } else {
          $log.warn("Missing or invalid valueType attribute.");
          return;
        }

        scope.latestValue = scope.history[0];

        //Bind deep link url
        if(attrs.link){
          scope.link = attrs.link
        }

        if (scope.history.length < 2 || scope.history[1] === 0 || scope.newlocation) {
          //No need to calculate change percentage for 1 value or new location (1 month old or less)
          return;
        }

        //Calculate value based on the type we want to display
        var previousValue = scope.history[1];

        //Calculate change value based on the type we want to display
        var changeValue;
        var changeValuePostfix = '';
        if (attrs.changeType === 'percentage') {
          if (previousValue === 0) {
            return;
          }

          changeValue = Math.round((scope.latestValue / previousValue - 1) * 100);
          changeValuePostfix = '%';
        } else if (attrs.changeType === 'absolute') {
          changeValue = scope.latestValue - previousValue;
          changeValuePostfix = '%';
        } else {
          $log.warn("Missing or invalid changeType attribute.");
          return;
        }

        changeValue = Math.round(changeValue);
        if (changeValue === 0) {
          scope.rankIconClass = 'rank-equal-icon';
          scope.changeText = '0' + changeValuePostfix;
        } else if (changeValue > 0) {
          scope.rankIconClass = 'rank-higher-icon';
          scope.rankIconImg = 'rank-higher-icon';
          scope.changeText = Math.abs(changeValue) + changeValuePostfix;
        } else if (changeValue < 0) {
          scope.rankIconClass = 'rank-lower-icon';
          scope.rankIconImg = 'rank-lower-icon';
          scope.changeText = Math.abs(changeValue) + changeValuePostfix;
        }
      });
    }
  }
}
])
;
